import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class CountryRiskService {
  static getList(encodedUrlParam,date,pageNumber,pageSize,key) {
    var url = (API_ROUTES.COUNTRYRISK.LIST).replace("<encodedUrlParam>", encodedUrlParam)
    .replace("<date>", date)
    .replace("<pageNumber>", pageNumber)
    .replace("<pageSize>", pageSize)
    .replace("<key>", key)
    return HttpUtil.get(url);
  }

  static saveData(encodedUrlParam,date,body) {
    return HttpUtil.post((API_ROUTES.COUNTRYRISK.SUBMIT).replace("<encodedUrlParam>", encodedUrlParam)
    .replace("<date>", date),body)
  }
}
